<template>
  <commonSelect
    :value="value"
    @select="(v,e,type)=>$emit('change',v,e,type)"
    @input="(v,e,type)=>$emit('input',v,e,type)"
    placeholder="请选择发票类型"
    :clearable="clearable"
    idKey="InvoiceTypeId"
    labelKey="InvoiceTypeName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/invoiceType").default,
    };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.list({Status: 1}).then((res) => {
          // 
          console.log('类型', res.Data)
          resolve({ Data: res.Data });
        });
      });
    },
  },
};
</script>

